import SummarizedBreakdown from "./SummarizedBreakdown";

export default class SinglePredictionsStats {
  public predictionsMade: number = 0;
  public correct: number = 0;
  public points: number = 0;
  public breakdown: SummarizedBreakdown = new SummarizedBreakdown();
}
